import { languageOptions } from "./i18n";

export const getTranslateData = ({
  locale,
  languageData,
}: {
  locale: string;
  languageData: { [key: string]: string };
}) => {
  if (!languageData) {
    return "";
  }
  const curCode =
    languageOptions.find((item) => item.value === locale)?.code || "";
  return languageData[curCode];
};
